import { createSelector } from "reselect";

import { RootState } from "../../store/types";
import { ColorChoiceState } from "./reducer";
import { Color } from "../../models";

const transformColor = (color: Color) => ({
  ...color,
  position: Number(color.position),
});

export const colorChoice = (state: RootState): ColorChoiceState =>
  state.wizardColorChoice;

export const colors = createSelector(colorChoice, state =>
  state.colors.map(transformColor).sort((a, b) => a.position - b.position),
);

export const chosenColor = createSelector(
  colorChoice,
  state => state.chosenColor,
);

export const isColorsLoading = createSelector(
  colorChoice,
  state => state.isColorsLoading,
);

export const checkboxChecked = createSelector(
  colorChoice,
  state => state.customColorsChecked,
);



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/selectors.ts